import { useIntl } from 'react-intl';
import { IResolveParams, LoginSocialFacebook } from 'reactjs-social-login';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import AuthButton from 'pages/authentication/components/social-auth-buttons/auth-button';
import FacebookIcon from 'pages/authentication/components/social-auth-buttons/facebook/icon';
import {
  SocialLoginParams,
  UserAuth,
} from 'pages/authentication/components/social-auth-buttons/types';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { facebookClientIds } from 'utils/environment';

const FacebookAuthButton = ({
  isLoading,
  isDisabled,
  onSuccess,
  onError,
  onStart,
}: SocialLoginParams) => {
  const { logEvent } = useMParticleContext();
  const { formatMessage } = useIntl();
  const authButton = (
    <AuthButton
      label={formatMessage({ id: 'logInWithFacebook' })}
      icon={<FacebookIcon />}
      loading={isLoading}
      disabled={isLoading || isDisabled}
    />
  );

  return (
    <ActionButton
      fullWidth
      borderColor={Styles.color.black}
      marginY="$2"
      variant={ActionButtonVariants.OUTLINE}
      disabled={isLoading || isDisabled}
    >
      {/*On IOS mobile web, the LoginSocial component doesn't take care about disabling the child button, and
          it fires the click event, to solve this we just return the disabled button without the LoginSocial component*/}
      {isDisabled ? (
        authButton
      ) : (
        <LoginSocialFacebook
          appId={facebookClientIds.appID}
          onResolve={({ data }: IResolveParams) => {
            logEvent(CustomEventNames.SOCIAL_LOGIN_FACEBOOK_SUCCESS, EventTypes.Other);
            const userInfo: UserAuth = {
              name: data?.name,
              email: data?.email,
              token: data?.accessToken,
            };
            onSuccess(userInfo);
          }}
          onReject={error => {
            logEvent(CustomEventNames.SOCIAL_LOGIN_FACEBOOK_ERROR, EventTypes.Other, {
              error,
            });
            onError(error);
          }}
          onLoginStart={() => {
            logEvent(CustomEventNames.SOCIAL_LOGIN_FACEBOOK_CLICK, EventTypes.Other);
            onStart();
          }}
        >
          {authButton}
        </LoginSocialFacebook>
      )}
    </ActionButton>
  );
};

export default FacebookAuthButton;
